import React from "react";

const FlowerNail = () => {
  return (
    <div className="blogWhat-content">
      <h5>10. Pressed Flower Nails: Nature-Inspired Beauty</h5>
      <p>
        Bringing a touch of nature to your manicure,{" "}
        <a href="https://scentlifestyle.com/classic-pedicure">
          pressed flower nails
        </a>
        feature real or faux floral pieces encapsulated in clear or pastel gel
        polish. Whether you choose tiny dried flowers, leaf patterns, or
        delicate botanical prints, this trend is perfect for those who love a
        whimsical and feminine aesthetic.
      </p>
    </div>
  );
};

export default FlowerNail;
